import styled from '@emotion/styled';
import { COLORS, RADIUSES } from '@sortlist-frontend/design-system/legacy';

export const Iframe = styled.iframe`
  border: 0;
`;

export const YouTubeEmbed = styled.div<{ isPlayed?: boolean; placeholder?: string }>`
  ${({ isPlayed, placeholder }) => `
    position: relative;



    &:before {
      width: 100%;
      height: 100%;
      background: ${placeholder ? `url(${placeholder}) no-repeat center center;` : COLORS.SECONDARY_900};
      ${placeholder ? `background-size: cover;` : ''}
      position: absolute;
      display: ${!isPlayed ? 'block' : 'none'};
      content: '';
      top: 0;
      left: 0;
      border-radius: ${RADIUSES.lg};
    }
  `}
`;

export const PlayFab = styled.div`
  left: 50%;
  top: 50%;
  transform: translate(-1.1875rem, -1.1875rem) !important;
`;
